import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import debounce from 'lodash.debounce';
import FairDropdown from '../FairDropdown/FairDropdown';
import searchGrey from '../../../../../assets/images/search-grey.svg';

class FairFiltersBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: props.searchTerm || '',
        };

        this.debouncedSearch = debounce((searchTerm) => {
            this.props.onSearch(searchTerm);
        }, 1000);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchTerm !== this.props.searchTerm) {
            this.setState({ searchTerm: this.props.searchTerm || '' });
        }
    }

    componentWillUnmount() {
        this.debouncedSearch.cancel();
    }

    handleSearchChange = (event) => {
        const searchTerm = event.target.value;
        this.setState({ searchTerm });
        this.debouncedSearch(searchTerm);
    };

    handleSearchSubmit = (event) => {
        event.preventDefault();
        this.debouncedSearch.cancel();
        this.props.onSearch(this.state.searchTerm);
    };

    handleSearchClear = () => {
        this.debouncedSearch.cancel();
        this.setState({ searchTerm: '' });
        this.props.onSearch('');
    };

    getProductTypeOptions = () => {
        const {
            intl,
            allItemsCount,
            promotionsItemsCount,
            clientItemsCount,
            cartItemsCount,
        } = this.props;

        return [
            {
                value: 'all',
                label: `${intl.formatMessage({
                    id: 'fair.filters.all_items',
                })} (${allItemsCount || 0})`,
            },
            {
                value: 'promotions',
                label: `${intl.formatMessage({
                    id: 'fair.filters.promotions_items',
                })} (${promotionsItemsCount || 0})`,
            },
            {
                value: 'client',
                label: `${intl.formatMessage({
                    id: 'fair.filters.client_items',
                })} (${clientItemsCount || 0})`,
            },
            {
                value: 'cart',
                label: `${intl.formatMessage({
                    id: 'fair.filters.cart_items',
                })} (${cartItemsCount || 0})`,
            },
        ];
    };

    getSupplierOptions = () => {
        const { suppliers } = this.props;

        return (Array.isArray(suppliers) ? suppliers : [])
            .filter(
                (supplier) =>
                    supplier &&
                    supplier.id !== undefined &&
                    supplier.id !== null
            )
            .map((supplier) => ({
                value: String(supplier.id),
                label: supplier.description || String(supplier.id),
            }));
    };

    render() {
        const {
            intl,
            selectedProductType,
            selectedSuppliers,
            onProductTypeChange,
            onSuppliersChange,
        } = this.props;
        const { searchTerm } = this.state;
        const allSuppliersLabel = intl.formatMessage({
            id: 'fair.filters.select.all_suppliers',
        });

        return (
            <div className="fair-filters-bar">
                <FairDropdown
                    options={this.getProductTypeOptions()}
                    value={selectedProductType}
                    onChange={onProductTypeChange}
                    clearValue="all"
                    placeholder={intl.formatMessage({
                        id: 'fair.filters.all_items',
                    })}
                />
                <FairDropdown
                    multi
                    searchable
                    options={this.getSupplierOptions()}
                    value={selectedSuppliers}
                    onChange={onSuppliersChange}
                    placeholder={allSuppliersLabel}
                    allSelectedLabel={allSuppliersLabel}
                />
                <form
                    className="fair-filters-bar__search"
                    onSubmit={this.handleSearchSubmit}
                >
                    <img
                        src={searchGrey}
                        alt=""
                        className="fair-filters-bar__search-icon"
                        onClick={this.handleSearchSubmit}
                    />
                    <input
                        type="text"
                        className="fair-filters-bar__search-input"
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        placeholder={intl.formatMessage({
                            id: 'table.search.placeholder',
                        })}
                    />
                    {!!searchTerm && (
                        <button
                            type="button"
                            className="fair-filters-bar__search-clear"
                            onClick={this.handleSearchClear}
                        >
                            +
                        </button>
                    )}
                </form>
            </div>
        );
    }
}

FairFiltersBar.propTypes = {
    allItemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    promotionsItemsCount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    clientItemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    cartItemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    selectedProductType: PropTypes.string,
    selectedSuppliers: PropTypes.arrayOf(PropTypes.string),
    suppliers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            description: PropTypes.string,
        })
    ),
    searchTerm: PropTypes.string,
    onProductTypeChange: PropTypes.func.isRequired,
    onSuppliersChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(FairFiltersBar);
